jQuery( document ).ready(function( $ ) {   
    // Search closer
    $(".modal-closer").on('click', function(){
        $('.modal').hide();
        $('html, body').css({
            overflow: 'auto',
            height: 'auto'
        });
    });

    // Accordion Block
    if ($('.faq__question').length > 0) {
        $('.faq__question').on('click', function(event){
            event.preventDefault();
            $(this).siblings('.faq__answer').slideToggle();
            $(this).find('.icon__closed').toggle();
            $(this).find('.icon__open').toggle();
        });

        // Open if id is in url
        var current = window.location.hash;

        if (current.length > 0) {
            $(current).trigger('click');
        }

        if($('.open-all-faq').length > 0) {
            $('.open-all-faq').each(function () {
                var containerId = $(this).attr('id');

                $('#' + containerId + ' .faq__question').on('click', );
            });
        }

    }

    // Mobile Nav
    // Mobile toggle
    $( '.navbar-burger' ).on('click', function(){
        $('.open').toggle();
        // purchase form not playing nicely with menu. Let's hide it
        $("#nf-form-4-cont").toggle();
        //$('#header-width').toggleClass('black-main-nav');
        // $('body').toggleClass('fixed');
        // $('.navbar-burger').toggleClass('burger-background');
        $('.closed').toggle();
        $('#mobile-menu').slideToggle(500);
        if ($('.open').is(':visible')) {
            $('body').css('overflow', 'auto');
        }
        else {
            $('body').css('overflow', 'hidden');
        }
    });

    if ($(".menu-toggle").length > 0) {
        $(".menu-toggle").on('click', function(){
            $(this).closest('li').find('.menu-level-2').slideToggle();
            $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
        })
    }

    if ($(".menu-toggle-2").length > 0) {
        $(".menu-toggle-2").on('click', function(){
            $(this).closest('li').find('.menu-level-3').slideToggle();
            $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
        })
    }

    if ($(".menu-toggle-3").length > 0) {
        $(".menu-toggle-3").on('click', function(){
            $(this).closest('li').find('.menu-level-4').slideToggle();
            $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
        })
    }

    if ($(".menu-toggle-4").length > 0) {
        $(".menu-toggle-4").on('click', function(){
            $(this).closest('li').find('.menu-level-5').slideToggle();
            $(this).closest('li').find('svg').eq(0).toggleClass('rotate-90');
        })
    }

    // nasty hack to remove empty ul tags in menu for accessibility
    $('#nav-upper ul').not(':has(li)').remove();

    if ($('.photo-gallery-slider').length > 0 ) {
        $('.photo-gallery-slider').slick({
            autoplay: true,
            arrows: true,
            dots: true,
            speed: 500,
            slidesToShow: 1,
            appendDots: $('.append-dots'),
        });
    }

    if ($('.home-slider').length > 0 ) {
       var image_height = 0;
        window.addEventListener('resize', function () {
            "use strict";

            image_height = setSliderPosition();

        });


        $('.home-slider__slides').slick({
            autoplay: true,
            arrows: false,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            useTransform: true,
        });

        $('.home-slider__slides2').slick({
            autoplay: true,
            arrows: false,
            dots: true,
            speed: 500,
            slidesToShow: 1,
            appendDots: $('.append-dots'),
        });

        // Pointer animation stuff
        image_height = setSliderPosition();

        $('.home-slider__slides').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            
            if (nextSlide == 0) {
                $('.rectangle').show();
                 $('.pointer-wrapper').animate({top: '2rem'});
                setTimeout(function () {
                    $('.pet-1').css({"color":"white","background":"#41748D"});
                    $('.pet-1 svg').css({"fill":"white"});
                    $('.rectangle').hide()
                }, 500);
                $('.pet-2').css({"color":"#41748D","background":"#215c79"});
                $('.pet-3').css({"color":"#41748D","background":"#215c79"});


                $('.pet-2 svg, .pet-3 svg').css({"fill":"#41748D"});
            }

            if (nextSlide == 1) {
                $('.rectangle').show();
                var mytop = image_height * .33 + 38 + 'px';
                $('.pointer-wrapper').animate({top: mytop});
                setTimeout(function () {
                    $('.pet-2').css({"color":"white","background":"#41748D"});
                    $('.pet-2 svg').css({"fill":"white"});
                    $('.rectangle').hide()
                }, 500);

                $('.pet-1').css({"color":"#41748D","background":"#215c79"});
                $('.pet-3').css({"color":"#41748D","background":"#215c79"});

                $('.pet-1 svg, .pet-3 svg').css({"fill":"#41748D"});

            }

            if (nextSlide == 2) {
                $('.rectangle').show()
                var mytop = image_height * .66 + 38 + 'px';
                $('.pointer-wrapper').animate({top: mytop});
                setTimeout(function () {
                    $('.pet-3').css({"color":"white","background":"#41748D"});
                    $('.pet-3 svg').css({"fill":"white"});
                    $('.rectangle').hide();
                }, 500);
                $('.pet-2').css({"color":"#41748D","background":"#215c79"});
                $('.pet-1').css({"color":"#41748D","background":"#215c79"});

                $('.pet-1 svg, .pet-2 svg').css({"fill":"#41748D"});
            }


        });

        $(".slider-pause").on('click', function(){
            $('.home-slider__slides').slick('slickPause');
            $(".slider-pause").toggle();
            $('.slider-play').toggle();
        });

        $(".slider-play").on('click', function(){
            $('.home-slider__slides').slick('slickPlay');
            $('.slider-play').toggle();
            $(".slider-pause").toggle();
        });       
    }

    function setSliderPosition() {
         // Pointer animation stuff
         var image_left = $('.header-image img').width();
         var image_height = $('.header-image img').height();
         var remaining_width = $('.home-slider').width() - image_left;
         var pointer_height = image_height * .33 +'px';
         $('.pointer-wrapper svg').css("height", pointer_height);
         $('.pointer-wrapper').css("left", image_left);
 
         var left_offset = "-"+ $('.pointer-left').width()+"px";
         console.log(left_offset);
 
         $('.pointer-left').css({'left': left_offset});
         $('.pointer-wrapper svg').css("padding-right", left_offset);
 
         $('.slide-links').css('left', image_left);
         $('.slide-links').css('height', image_height);
         $('.slide-links').css('width', remaining_width);
 
         $('.rectangle').css({"width": remaining_width,"height":pointer_height});
         $('.rectangle').hide();
 
         $('.pet-1').css({"color":"white","background":"#41748D"});
         $('.pet-1 svg').css({"fill":"white"});

         return image_height;
 
    }

    SectionScroll.adjust();
   
    $('a.scroll-to-section').on('click', function (e) {
        let url = $(this).attr('href');
           
        if (url.startsWith('#')){
          e.preventDefault();
          SectionScroll.adjustManual(url);      
        }
    });


});

let SectionScroll = {
    
    adjust: function(){

        //avoid browser restore previous scroll position
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }

        //check if we have a section id 
        let sectionId = window.location.hash;

        if(sectionId){
            //check if the id exists in the page
            let el = document.querySelector(sectionId);
            
            SectionScroll.scroll(el);            
        }
    },
    adjustManual: function(hash){     
        //check if the id exists in the page
        let el = document.querySelector(hash);
        SectionScroll.scroll(el);        
    },
    scroll: function (el){
        if(el){
            //if the section exists then scroll with an offset of the nav bar (and 25 of margin)
            let navOffset = document.querySelector('header').offsetTop;
            let sectionOffset = el.offsetTop - navOffset - 15;

            console.log(sectionOffset);

            scroll({
                top: sectionOffset,
                behavior: "smooth"
            });
        }
    }
}

 //News filter
 document.addEventListener('DOMContentLoaded', function () {
    const button = document.getElementById('newslistButton');
    const menu = document.getElementById('newslistMenu');
    const label = document.getElementById('newslistLabel');
    const arrow = document.getElementById('dropdownArrow');

    // Set initial label from the selected item
    const selectedItem = menu.querySelector('a[data-selected]');
    if (selectedItem) {
      label.textContent = selectedItem.textContent.trim();
    }

    // Toggle dropdown visibility
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      menu.classList.toggle('hidden');
      arrow.classList.toggle('rotate-180');
    });

    // Handle item selection
    menu.querySelectorAll('a').forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();

        const value = option.getAttribute('data-value');
        const text = option.textContent.trim();

        // Update label
        label.textContent = text;

        // Redirect as per filter
        const currentURL = window.location.protocol + '//' + window.location.host + window.location.pathname;
        if (value === '-1') {
          window.location.href = currentURL;
        } else {
          window.location.href = currentURL + '?news_type=' + encodeURIComponent(value);
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function () {
      menu.classList.add('hidden');
      arrow.classList.remove('rotate-180');
    });
  });

